import { render } from "./ProgressBar.vue?vue&type=template&id=3146b8ab&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=3146b8ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3146b8ab"

export default script